var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M245.4,425.4c22.5-3.6,25.7,28.3,6.5,31.5-22.5,3.6-25.7-28.3-6.5-31.5Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M266,32.1c80.2,8,128,95.1,87.7,166.7-39.6,70.6-139.4,76.1-187.4,11.1-51.2-69.4-5.5-171,80.5-177.8h19.2ZM248.4,60.3c-51.9,4.6-86.4,56.1-72.7,106.2,17.5,63.8,100.5,82.5,144,32.3s3.8-145.2-71.3-138.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.9,283.8c99.2-6.2,188.6,71.2,193.1,171.3.5,11.5.6,22.5-13.5,24H88.4c-14.1-1.5-14-12.6-13.5-24,4.1-91,79.8-165.6,170-171.3ZM409.2,451.1c-4.8-64.3-53.3-120-115.7-135.2-91.4-22.3-181.9,41.9-189.8,135.2h305.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.640d5e69c131552e532d1e23b3fde7b2.svg";
export { ForwardRef as ReactComponent };